
<mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
<app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

<ngx-gallery #gallery [options]="galleryOptions" (imagesReady)="onImagesReady($event)" (thumbOnRightClick)="thumbOnRightClick($event)" [activeLog]="false"></ngx-gallery>
<ng-template #ctxMenu let-item>
	<section class="ctx-menu" >
		<div *ngFor="let action of item.actions" (click)="action.action($event, item)">{{action.description}}</div>
	</section>
</ng-template>


<!-- <carousel (activeSlideChange)="activeIndex=$event">
    <slide *ngFor="let slide of galleryImages; let currentIndex = index;">
      <img src="getImage(currentIndex)" *ngIf="currentIndex = activeIndex">
    </slide>
  </carousel> -->
<!-- <div style="height: 100px;">


    <div *ngFor="let slide of galleryImages; let currentIndex = index;">
        <a class="ngx-gallery-thumbnail ng-star-inserted ngx-gallery-clickable" href="#" target="_blank"
            aria-label="M16-F01-C19"
            style="background-image: url({{slide.small}}); width: calc(14.2857% - 8.57143px); height: calc(100% - 0px); left: calc(14.2857% + 1.42857px); top: calc(0% + 0px);">
            <div class="ngx-gallery-icons-wrapper"></div>
        </a>
    </div>
</div> -->